module.exports = __webpack_public_path__ + "item.variations-multiselect-db5896d1.html";